import API from "@/api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async paymentBoleto({ state }, payable) {
      try {
        return await API.Payments.paymentViaBoleto(payable);
      } catch (e) {
        throw e;
      }
    },

    async paymentCreditCard({ state }, payload) {
      try {
        return await API.Payments.paymentViaCreditCard(payload);
      } catch (e) {
        throw e;
      }
    },

    async getPayment({ state }, payload) {
      try {
        return await API.Payments.getPayment(payload);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/payments.js